<template>
    <footer
        class="md-footer broker"
        :style="{
            backgroundColor: bgColor,
            color: fontColor,
            ...colorMapStyle
        }"
        :class="[{ inner: inner }, fixedZindexCls]"
    >
        <div class="md-footer__wrapper">
            <!-- LOGOS START -->
            <template v-if="logos.length > 0">
                <div class="md-footer__logos">
                    <template v-for="(logo, index) in validLogos">
                        <a
                            v-if="logo.logo.href"
                            :key="index"
                            :href="logo.logo.href"
                            rel="noopener noreferrer"
                        >
                            <site-img
                                class="logo-item"
                                :src="logo.logo"
                                :style="{ height: size / 100 + 'em' }"
                                :ssrInitSize="30"
                                dir="height"
                            />
                        </a>
                        <site-img
                            v-else
                            class="logo-item"
                            :key="'key-' + index"
                            :src="logo.logo"
                            :style="{ height: size / 100 + 'em' }"
                            :ssrInitSize="30"
                            dir="height"
                        />
                    </template>
                </div>
            </template>
            <!-- LOGOS END -->
            <!-- MENUS AND AGENT INFO START -->
            <div class="md-footer__menus-detail">
                <ul class="md-footer__menus" role="menu" :style="useMenuStyle">
                    <menu-item
                        v-for="(menu, index) in z_menus"
                        :key="index"
                        :selfKey="'menu-' + index"
                        :expandKey="expandKey"
                        :menu="menu"
                        :useMenuStyle="useMenuStyle"
                        :useSubMenuStyle="useSubMenuStyle"
                        @updateExpandKey="updateExpandKey"
                    />
                </ul>
                <div class="md-footer__detail">
                    <!-- SOCIAL NETWORK START -->
                    <template v-if="socialNetworksInfo.length > 0">
                        <div class="share-links">
                            <a
                                v-for="(social, index) in socialNetworksInfo"
                                :key="social.id + '-' + index"
                                class="share-item"
                                :style="useCopyStyle"
                                :href="social.url"
                                :aria-label="social.socialNetwork"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <i class="iconfont" :class="social.icon"></i>
                            </a>
                        </div>
                    </template>
                    <!-- SOCIAL NETWORK END -->
                    <!-- COMPANY INFO START -->
                    <template v-if="companyInfo">
                        <div
                            v-if="companyInfo.name"
                            class="co-name"
                            :style="useBroNameStyle"
                            v-html="companyInfo.name"
                        ></div>
                    </template>
                    <!-- COMPANY INFO END -->
                    <!-- AGENT INFO START -->
                    <p class="md-footer__agent-info lh">
                        <template
                            v-if="
                                !!footerAgentInfo.firstName ||
                                    !!footerAgentInfo.lastName
                            "
                        >
                            <span
                                class="info-name mr-20"
                                :style="useAgentNameStyle"
                            >
                                {{ footerAgentInfo.firstName || '' }}
                                {{ footerAgentInfo.lastName || '' }}
                            </span>
                        </template>
                        <template v-if="!!footerAgentInfo.license">
                            <span
                                :style="useAgentLicenseStyle"
                                class="info-license"
                            >
                                {{ global.licenseName }}
                                {{ footerAgentInfo.license }}
                            </span>
                        </template>
                    </p>
                    <p class="md-footer__agent-info lh">
                        <template v-if="!!footerAgentInfo.phone">
                            <span
                                class="info-phone mr-20"
                                :style="useAgentPhoneStyle"
                            >
                                <a
                                    :href="'tel:' + footerAgentInfo.phone"
                                    target="_top"
                                    rel="noopener noreferrer"
                                >{{
                                    $ft.formatPhone(footerAgentInfo.phone)
                                }}</a>
                            </span>
                        </template>
                        <template v-if="!!footerAgentInfo.email">
                            <span
                                class="info-email"
                                :style="useAgentEmailStyle"
                            >
                                <a
                                    :href="'mailto:' + footerAgentInfo.email"
                                    rel="noopener noreferrer"
                                >{{ footerAgentInfo.email }}</a>
                            </span>
                        </template>
                    </p>
                    <!-- subdomain owner info -->
                    <template v-if="subOwnerInfo">
                        <p class="md-footer__agent-info lh">
                            <span
                                v-if="
                                    !!subOwnerInfo.firstName ||
                                        !!subOwnerInfo.lastName
                                "
                                class="info-name"
                                :style="useAgentNameStyle"
                            >
                                {{ subOwnerInfo.firstName || '' }}
                                {{ subOwnerInfo.lastName || '' }}
                            </span>
                        </p>
                        <p class="md-footer__agent-info lh">
                            <span
                                v-if="!!subOwnerInfo.phone"
                                class="info-phone mr-20"
                                :style="useAgentPhoneStyle"
                            >
                                <a
                                    :href="'tel:' + subOwnerInfo.phone"
                                    target="_top"
                                    rel="noopener noreferrer"
                                >
                                    {{ $ft.formatPhone(subOwnerInfo.phone) }}
                                </a>
                            </span>
                            <span
                                v-if="!!subOwnerInfo.email"
                                class="info-email"
                                :style="useAgentEmailStyle"
                            >
                                <a
                                    :href="'mailto:' + subOwnerInfo.email"
                                    rel="noopener noreferrer"
                                >
                                    {{ subOwnerInfo.email }}
                                </a>
                            </span>
                        </p>
                    </template>
                    <template v-if="getAddressInfo">
                        <div
                            class="co-address lh"
                            :style="useBroAddrStyle"
                            v-html="getAddressInfo"
                        ></div>
                    </template>

                    <template v-if="footerAgentCustomContent">
                        <div
                            class="custom-content"
                            :style="{ color: fontColor }"
                            v-html="formatFontSize(footerAgentCustomContent)"
                        ></div>
                    </template>

                    <div class="md-footer__agent-info lh agent-file">
                        <template v-if="agentHasDisclaimer">
                            <p
                                v-for="(
                                    file, index
                                ) in footerAgentInfo.disclaimerList"
                                :key="index + 'mainfile'"
                                class="info-file"
                            >
                                <a :href="file.url" rel="noopener noreferrer">
                                    {{ file.name.split('.')[0] }}
                                </a>
                            </p>
                        </template>
                        <template v-if="subOwnerHasDisclaimer">
                            <p
                                v-for="(
                                    file, index
                                ) in subOwnerInfo.disclaimerList"
                                :key="index + 'subfile'"
                                class="info-file"
                            >
                                <a :href="file.url" rel="noopener noreferrer">
                                    {{ file.name.split('.')[0] }}
                                </a>
                            </p>
                        </template>
                    </div>
                    <!-- DISCLAIMER START -->
                    <div class="no-mls-disclaimer texas-mls" v-if="hasTeaxsMls">
                        <a
                            href="https://www.trec.texas.gov/sites/default/files/pdf-forms/CN%201-3.pdf"
                            target="_blank"
                            :title="$t('md-footer.realEstateConsumer')"
                            rel="noopener noreferrer"
                        >{{ $t('md-footer.realEstateConsumer') }}</a>
                    </div>
                    <div
                        class="no-mls-disclaimer"
                        v-if="noMlsDisclaimers.length > 0"
                    >
                        <div
                            class="claimer"
                            v-for="(noMls, index) in noMlsDisclaimers"
                            :key="index"
                            v-html="noMls.label"
                        ></div>
                    </div>
                    <!-- DISCLAIMER END -->
                    <!-- AGENT INFO END -->
                </div>
            </div>
            <!-- MENUS AND AGENT INFO END -->
            <!-- COPYRIGHT START -->
            <closely-app-download useModule="md-footer" />
            <a class="md-footer_notshare" v-if="isDoNotShareShow" href="/site/dsar">{{ $t('md-footer.doNotShare') }} --> </a>
            <template v-if="!hideCopyRight">
                <div class="md-footer__copyright" :style="useCopyStyle">
                    <template v-if="gfFlag != '1'">
                        <p class="ppt">
                            <CopyrightLink :gfFlag="gfFlag" :isShowAccessibility="isShowAccessibility" /> 
                        </p>
                        <p
                            class="cr"
                            v-if="showCopyright"
                            v-html="
                                $t('md-footer.madeInAndCopyright', {
                                    chimeLink,
                                    year
                                })
                            "
                        ></p>
                    </template>
                    <template v-else>
                        <p class="ppt">
                            <CopyrightLink :gfFlag="gfFlag" :isShowAccessibility="isShowAccessibility" /> 
                        </p>
                        <p class="cr">
                            {{ $t('md-footer.geographicFarmingLlc', { year }) }}
                        </p>
                    </template>
                </div>
            </template>
            <!-- COPYRIGHT END -->
            <div class="md-footer__split"></div>
            <!-- MLS DISCLAIMER START -->
            <MlsDisclaimer
                v-if="!wordPressSSR"
                theme="broker"
                @update="mlsUpdated"
            />
            <!-- MLS DISCLAIMER END -->
        </div>
    </footer>
</template>

<script>
import common from '../index';

export default {
    mixins: [common],
    data: function() {
        return {};
    }
};
</script>

<style lang="scss">
@import '../../../theme/media.scss';
@import '../../../theme/mixin.scss';
@import '.././index.scss';

.md-footer.broker {
    .md-footer__wrapper {
        padding: 40px 50px;
    }

    .md-footer__logos {
        font-size: 40px;

        & > *:not(:first-child) {
            margin-left: 50px;
        }
    }

    .md-footer__menus-detail {
        margin-top: 40px;
        display: flex;
        flex-wrap: wrap;
    }

    .md-footer__menus {
        flex: 3;

        .menu-item {
            width: 33.3%;
            cursor: pointer;
            padding-bottom: 20px;
            padding-left: 0;
            display: inline-block;
            vertical-align: text-top;

            & > a {
                display: flex;
                position: relative;
                max-width: 100%;
                @include ellipsis();

                &.hasChild {
                    display: flex;
                }
            }

            .footer-menu {
                line-height: 2.15;
                cursor: pointer;

                .icon-arrow-down {
                    font-size: inherit;
                    position: relative;
                    left: 4px;
                    display: inline-block;
                    transform: scale(0.7, 0.8);
                }

                &.down .icon-arrow-down {
                    transform: rotate(180deg) scale(0.7, 0.8);
                }
            }

            .footer-submenu {
                font-size: 12px;
                margin-top: 10px;

                .sub-menu {
                    a:hover {
                        text-decoration: underline;
                    }

                    & + .sub-menu {
                        margin-top: 10px;
                    }
                }
            }
        }
    }

    .md-footer__detail {
        flex: 2;
        font-size: 14px;

        .co-name {
            line-height: 1.25;
            font-size: 16px;
        }

        .lh {
            line-height: 1.43;
        }

        .mr-20 {
            margin-right: 20px;
        }

        .co-name,
        .co-address {
            margin-bottom: 10px;
        }

        .co-address {
            margin-top: 20px;
        }

        .md-footer__agent-info {
            display: flex;
            flex-wrap: wrap;

            &.agent-file {
                display: block;
            }

            .info-file {
                display: block;
                cursor: pointer;
                color: #a0a0a0;
            }

            & + .md-footer__agent-info {
                margin-top: 10px;
            }
        }

        @include no-mls-disclaimer();

        .no-mls-disclaimer {
            margin-top: 25px;
        }

        .share-links {
            margin-bottom: 20px;
            display: flex;
            flex-wrap: wrap;
            gap: 20px;

            .share-item {
                &:hover {
                    .iconfont {
                        color: #fff;
                    }
                }

                .iconfont {
                    font-size: 20px;
                    color: #aaaaaa;
                }
            }
        }
    }

    .download-closely {
        .code-wrapper {
            justify-content: start;

            .android {
                margin-left: 30px;
            }
        }
    }
    .md-footer_notshare{
        margin-top: 10px;
        display: block;
    }
    .md-footer__copyright {
        margin-top: 30px;
        font-size: 12px;
        color: #dedede;

        .cr,
        .ppt {
            line-height: 1.67;
            a {
                white-space: nowrap;
            }
        }

        .cr {
            margin-top: 10px;
        }
    }

    .md-footer__split {
        margin-top: 40px;
        border-top: solid 1px rgba(80, 80, 80, 0.5);
        width: 100%;
    }

    .md-footer__mls {
        font-size: 12px;

        .mls-content {
            margin-top: 40px;

            .mls-logo {
                margin-bottom: 15px;

                img {
                    height: 30px;
                    width: auto;
                }
            }

            div {
                line-height: 1.67;
            }
        }
    }

    &.inner {
        .md-footer__wrapper {
            padding: 30px 20px;
        }

        .md-footer__menus-detail {
            display: block;
        }

        .md-footer__detail {
            margin-top: 40px;
        }
    }

    .fair-house-logo {
        vertical-align: text-bottom;
        margin: 0 5px;
        padding-top: 5px;
    }

    @include media-600 {
        .md-footer__wrapper {
            padding: 25px 15px;
        }

        .md-footer__menus-detail {
            margin-top: 25px;
        }

        .md-footer__menus {
            display: none;
        }

        .md-footer__logos {
            font-size: 25px;
            overflow: hidden;
        }

        .md-footer__copyright {
            margin-top: 25px;
        }

        .download-closely {
            margin-top: 20px;
            margin-bottom: -17px;
        }

        .md-footer__split {
            margin-top: 25px;
        }

        .md-footer__mls {
            .mls-content {
                margin-top: 25px;
            }
        }

        .md-footer__detail {
            .co-address {
                margin-top: 10px;
                margin-bottom: 5px;
            }
        }
    }
}
</style>
